import React, { useEffect } from 'react';

export const GoogleAnalytics: React.FC = () => {
    useEffect(() => {
        const updateConsent = () => {
            const saved = localStorage.getItem('cookie-consent-settings');
            if (saved) {
                try {
                    const settings = JSON.parse(saved);
                    if (settings.analytics) {
                        console.log('Google Analytics Consent Granted');
                        window.gtag('consent', 'update', {
                            'analytics_storage': 'granted'
                        });
                    }
                    if (settings.marketing) {
                        console.log('Marketing Consent Granted');
                        window.gtag('consent', 'update', {
                            'ad_storage': 'granted',
                            'ad_user_data': 'granted',
                            'ad_personalization': 'granted'
                        });
                    }
                } catch (e) {
                    console.error('Error parsing cookie settings', e);
                }
            }
        };

        // Initial check in case user already consented
        updateConsent();

        // Listen for updates
        window.addEventListener('cookie-consent-updated', updateConsent);

        return () => {
            window.removeEventListener('cookie-consent-updated', updateConsent);
        };
    }, []);

    return null;
};

declare global {
    interface Window {
        dataLayer: any[];
        gtag: (...args: any[]) => void;
    }
}
